import { render } from "./FlyerView.vue?vue&type=template&id=61bc40a3&scoped=true"
import script from "./FlyerView.vue?vue&type=script&lang=js"
export * from "./FlyerView.vue?vue&type=script&lang=js"

import "./FlyerView.vue?vue&type=style&index=0&id=61bc40a3&scoped=true&lang=css"

import exportComponent from "/home/treim/code/applyhr/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61bc40a3"]])

export default __exports__